import clsx from "clsx";

const SkeletonType2: React.FC<{ className?: string }> = (props) => {
  return (
    <div role="status" className={clsx("w-[80%] animate-pulse", props?.className)}>
      <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-400 w-64 mb-3"></div>
      <div className="h-1.5 bg-gray-200 rounded-full dark:bg-gray-400  w-96 mb-2.5"></div>
      <div className="h-1.5 bg-gray-200 rounded-full dark:bg-gray-400  mb-2.5"></div>
      <div className="h-1.5 bg-gray-200 rounded-full dark:bg-gray-400  mb-2.5"></div>
      <div className="h-1.5 bg-gray-200 rounded-full dark:bg-gray-400  mb-2.5"></div>
      <div className="h-1.5 bg-gray-200 rounded-full dark:bg-gray-400  mb-2.5"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
export default SkeletonType2;
